<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 19/05/2025 17:23
  ~ **/
  -->

<div class="wrapper">
  <div class="wrapper-content">
    <inf-tab-container [tabManager]="tabManager" [bordered]="false">
      @if (tabManager.activeTab) {
        <div class="tab-content">
          <infl-standard-page-master-detail
            [ngClass]="{ hidden: tabManager.activeTab.contentId !== 'list' }"
            [CRUD]="CRUD"
            [factory]="factory"
            [model]="model"
            [displayDetails]="displayDetails"
            (actionClick)="onActionClick($event)"
          />
          @if (tabManager.activeTab.contentId !== 'list') {
            <infl-standard-page-form
              [entity]="tabManager.activeTab.data"
              [factory]="factory"
              [model]="model"
              (actionClick)="onActionClick($event)"
            />
          }
        </div>
      }
    </inf-tab-container>
  </div>

  <inf-dialog
    [type]="dialogType.confirm"
    [title]="'i18n.dialog.dialog-confirm-close-title' | translate"
    [confirmText]="{ yes: 'i18n.dialog.close', no: 'i18n.dialog.cancel' }"
    (action)="onActionDialogConfirmBeforeClose($event)"
  >
    {{ 'i18n.dialog.text-confirm-close' | translate }}
  </inf-dialog>
</div>
